import React,{Fragment, useState} from 'react';
import uuid from 'react-uuid';

const Formulario = ({crearCita}) => {
    
    //Crear State de Citas
    const[cita , actualizarCita] = useState({
        mascota:'',
        propietario:'',
        fecha:'',
        hora:'',
        sintomas:''

    });

    //Creando state para error  
    const [error ,actualizarError] = useState(false)


    //Funcion que se ejecuta cada que el usuario escribe en un punto
    const actualizarState = e =>{
       actualizarCita({
         //...cita esta tomando el espacio y guardandolo de la misma manera 
        ...cita,
        [e.target.name] : e.target.value
       })
    }

  

    //Extraer los valores
    const {mascota,propietario,fecha,hora,sintomas} = cita;
 
    //Cuando el usuario presione agregar cita
    const submitCita = e =>{
        e.preventDefault();
        
        //Validar 
            
        if(mascota.trim() ==='' || propietario.trim() === '' || fecha.trim() === '' || sintomas.trim() === ''){
            actualizarError(true);
            return;
        }
           
        //eliminar el mensaje previo de error
        actualizarError(false);

        //Asignar un Id
        cita.id = uuid();

        //Crear la cita 
        crearCita(cita);


        //Reiniciar el form
        actualizarCita({
            mascota:'',
            propietario:'',
            fecha:'',
            hora:'',
            sintomas:''
        })
    }

    return ( 
        <Fragment>
            <h2>Crear Cita</h2>

            {error ? <p className="alerta-error">Todos los campos son obligatorios</p>: null }

        <form onSubmit={submitCita}>

            <label>Nombre Mascota</label>
            <input
            type="text"
            name="mascota"
            className="u-full-width"
            placeholder="Nombre Mascota"
            onChange={actualizarState}
            value={mascota}
            />
            <label>Nombre Propietario</label>
            <input
            type="text"
            name="propietario"
            className="u-full-width"
            placeholder="Nombre Mascota"
            onChange={actualizarState}
            value={propietario}
            />
            <label>Fecha</label>
            <input
            type="date"
            name="fecha"
            className="u-full-width"
            onChange={actualizarState}
            value={fecha}
            />
             <label>Hora</label>
            <input
            type="time"
            name="Hora"
            className="u-full-width"
            onChange={actualizarState}
            placeholder="Hora aqui"
            value={hora}
            />
             <label>Sintomas</label>
            <textarea
            name="sintomas"
            className="u-full-width"
            onChange={actualizarState}
            value={sintomas}>
            
            </textarea>

            <button type="submit" className="u-full-width button-primary">
            Agendar Cita
            </button>
        </form>

        </Fragment>
     );
}
 
export default Formulario;